import React, { useState, useEffect } from "react";
import { ThemeProvider, createTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import loginbackground from "../../assets/loginbackground.png";
import backloginfo from "../../assets/backlog.png";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Container,
  Avatar,
  Stack,
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useLocalStorageContext } from "../../Context/LocalProvider";
import { useMode } from "../../theme";
import { useSnackbar } from "../../Context/SnackbarContext";
import { loginApis } from "../../Data/axios";
import { useDispatch } from "react-redux";
import { setUser } from "../../utils/userSlice";


const lighttheme = createTheme({
  palette: {
    mode: "light",
  },
});

const center = {
  position: "relative",
  top: ".2rem",
  margin: "auto",
};

function LoginPag() {
  const { showSnackbar } = useSnackbar();
  const [codeOpen, setCodeOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const navigate = useNavigate();
  const { data, saveData } = useLocalStorageContext();
  const [theme] = useMode();
  const breakpoint = theme.breakpoints.down("md");
  const dispatch = useDispatch();
  const isDown = useMediaQuery(breakpoint);

  const boxStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "75%",
    maxHeight: "70%",
    boxSizing: "border-box",
    bgcolor: isDown ? "" : "background.paper",
    boxShadow: 24,
  };

  useEffect(() => {
    if (data) navigate("/rptpl");
  }, [data, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email) {
      showSnackbar("Enter the email or EMP ID", "error");
      return;
    }
    codeOpen ? verificationForm() : submitForm();
  };

  const verificationItem = { identifier: email, code: verificationCode };

  async function verificationForm() {
    try {
      const formData = new FormData();
      for (const key in verificationItem) {
        if (verificationItem[key] !== undefined && verificationItem[key] !== null) {
          formData.append(key, verificationItem[key]);
        }
      }

      const result = await loginApis.verification(formData);

      // Check if user is a test user (empid starts with RPTPLTEST)
      const isTestUser = result.empid && result.empid.startsWith("RPTPLTEST");

      dispatch(setUser({
        empid: result.empid,
        name: result.name,
        permissions: result.permissions,
        token: result.token,
        image: result.image,
        role: result.role,
        isTestUser: isTestUser,
      }));

      showSnackbar("Welcome to Road Pilot!!", "success");
      saveData({
        name: result.name,
        empid: result.empid,
        image: result.image,
        role: result.role,
        token: result.token,
        permissions: result.permissions,
        isTestUser: isTestUser,
      }, 6 * 60 * 60000);

      // Navigate to appropriate dashboard based on user type
      if (isTestUser) {
        navigate("/test-dashboard");
      } else {
        navigate("/rptpl");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Verification failed';
      const errorStatus = error.response?.data?.status;
      
      if (errorStatus === 1601) {
        showSnackbar(errorMessage, 'error');
      } else {
        showSnackbar(errorMessage, 'error');
      }
    }
  }

  async function submitForm() {
    try {
      const formData = new FormData();
      formData.append('username', email);

      const result = await loginApis.add(formData);

      switch (result.status) {
        case "1605":
          showSnackbar("Invalid data. Please check your credentials.", "error");
          break;
        case "1600":
          showSnackbar("User has been suspended", "error");
          break;
        case "1601":
          showSnackbar("User has been revoked", "error");
          break;
        case "1603":
          showSnackbar("User has resigned", "success");
          break;
        case "1604":
          showSnackbar("User not found, Raise a ticket!!", "warning");
          break;
        case "1602":
          showSnackbar("Verification Code has been sent successfully!!", "success");
          setCodeOpen(true);
          break;
        default:
          showSnackbar("Unexpected response from server", "error");
      }
    } catch (error) {
      showSnackbar("An error occurred while processing your request", "error");
    }
  }

  return (
    <Box sx={{
      backgroundImage: `url(${loginbackground})`,
      backgroundSize: "cover",
      height: "100vh",
      color: "#f5f5f5",
      boxSizing: "border-box",
    }}>
      <Box sx={boxStyle}>
        <Grid container>
          {!isDown && (
            <Grid item xs={12} sm={12} lg={6}>
              <Box sx={{
                backgroundImage: `url(${backloginfo})`,
                backgroundSize: "cover",
                height: "100%",
                color: "#f5f5f5",
              }} />
            </Grid>
          )}
          <Grid item xs={12} sm={12} lg={6}>
            <Box sx={{
              backgroundColor: "#C0B476",
              maxHeight: "100%",
              padding: "1rem",
            }}>
              <ThemeProvider theme={lighttheme}>
                <Container>
                  <Box height={10} />
                  <Box sx={center}>
                    <Avatar sx={{ ml: "35px", mb: "4px", margin: "auto" }}>
                      <LockOpenIcon />
                    </Avatar>
                    <Typography component="h1" variant="h4" sx={{ textAlign: "center" }}>
                      Sign In
                    </Typography>
                  </Box>
                  <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2, bgcolor: "white" }}>
                    <Grid container spacing={1} sx={{ padding: "2rem" }}>
                      <Grid item xs={12}>
                        <TextField
                          required
                          fullWidth
                          id="email"
                          margin="normal"
                          label="Username"
                          name="email"
                          autoComplete="email"
                          autoFocus
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Grid>
                      {codeOpen && (
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            id="Verification Code"
                            margin="normal"
                            label="Verification Code"
                            name="Verification Code"
                            autoComplete="Verification Code"
                            onChange={(e) => setVerificationCode(e.target.value)}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{
                            borderRadius: 28,
                            padding: ".5rem 3rem",
                            backgroundColor: "#FF9A01",
                            '&:hover': { backgroundColor: "#FF9A01" }
                          }}
                        >
                          {codeOpen ? "Verify" : "Sign in"}
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack direction="row" spacing={2}>
                          <Typography variant="body1" component="span" sx={{ mt: "10px",color: "black" }}>
                            Any Problem in Login?{" "}
                            <span
                              style={{ color: "orange", cursor: "pointer" }}
                              onClick={() => navigate("/Login-help")}
                            >
                              Click Here
                            </span>
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                </Container>
              </ThemeProvider>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default LoginPag;
